import { defineResource } from '@tnn/core'
import { z } from 'zod'

export const vehicleTypes = ['pickup', 'truck6', 'truck10', 'trailer', 'reefer'] as const
export const vehicleStatuses = ['active', 'maintenance', 'inactive'] as const

export const vehicle = defineResource({
  app: 'tms',
  name: 'vehicle',
  path: 'vehicles',
  schema: z.object({
    plate: z.string().trim().min(2).max(20),
    province: z.string().trim().max(50).nullish(),
    type: z.enum(vehicleTypes),
    capacityKg: z.number().int().min(0).max(60000).nullish(),
    capacityPallets: z.number().int().min(0).max(60).nullish(),
    status: z.enum(vehicleStatuses).default('active'),
    /** A contract driver's own truck (รถร่วม): only they drive it */
    ownerDriverId: z.string().nullish(),
    notes: z.string().max(1000).nullish(),
  }),
  fields: {
    plate: { search: true, list: { width: 120, priority: 1 }, form: { span: 4 }, import: { aliases: ['ทะเบียน', 'ทะเบียนรถ'] } },
    province: { suggest: true, list: { priority: 2 }, form: { span: 4 } },
    type: { filter: true, list: { priority: 1 }, form: { span: 4 } },
    capacityKg: { list: { align: 'end', priority: 3 }, form: { span: 4 } },
    capacityPallets: { list: { align: 'end', priority: 3 }, form: { span: 4 } },
    status: {
      filter: true,
      tones: { active: 'success', maintenance: 'warning', inactive: 'neutral' },
      list: { priority: 1 },
      form: { span: 4 },
    },
    ownerDriverId: {
      type: 'ref',
      ref: { resource: 'tms.driver', where: { contractor: 'true' } },
      filter: true,
      list: { priority: 2 },
      form: { span: 6 },
      import: false,
    },
    notes: { type: 'textarea', form: { span: 12 } },
  },
  title: 'plate',
  defaultSort: 'plate',
  importKey: 'plate',
  card: { title: 'plate', subtitle: 'type', meta: ['province', 'capacityPallets'], status: 'status' },
})
